import { List, Stack } from "@mui/material";

import { AmbulanzWidget } from "@/common/components/ambulanzes/ambulanz-widget/AmbulanzWidget";
import { JournalSupportSection } from "@/common/components/journal-support/JournalSupportSection";
import { useAmbulanzesQuery } from "@/pages/ambulanzes/hooks/useAmbulanzesQuery";

import { AmbulanzesHeader } from "./components/header/AmbulanzesHeader";

export function Ambulanzes() {
  const { data } = useAmbulanzesQuery();
  const open = data?.open ?? [];

  return (
    <Stack flex={1} overflow="hidden" borderRadius={0.5} border={"1px solid"} borderColor={"fsw.blue-10"}>
      <AmbulanzesHeader count={data?.openCount ?? 0} />

      <List disablePadding sx={{ overflowY: "auto", flex: 1 }}>
        {open.map((ambulanz) => (
          <AmbulanzWidget key={ambulanz.ambulanzId} ambulanz={ambulanz} />
        ))}
      </List>

      <JournalSupportSection />
    </Stack>
  );
}
